import { useIdentity } from '@interhyp/platform-auth';
import { ToggleProvider, type ToggleProviderProps } from '@interhyp/platform-module';
import { ReactElement } from 'react';

/**
 * @deprecated use AUTHZ_ACTION_KEYS instead of config keys
 */
const CONFIG_KEYS = [
  'anonymize-enabled',
  'anonymize-manual-enabled',
  'blocking-block-enabled',
  'blocking-enabled',
  'blocking-unblock-enabled',
  'consumer-credit-edit-external-enabled',
  'consumer-credit-enabled',
  'is-allowed-to-copy-intents',
  'is-allowed-to-create-intents',
  'is-allowed-to-retrieve-existing-loans',
  'mfa-settings-access',
];

const AUTHZ_ACTION_KEYS: string[] = [];

export function LocalToggleProvider({
  children,
}: Pick<ToggleProviderProps, 'children'>): ReactElement {
  const identity = useIdentity();

  return (
    <ToggleProvider
      configDefinitionKeys={CONFIG_KEYS}
      authzActionKeys={AUTHZ_ACTION_KEYS}
      identity={identity}
    >
      {children}
    </ToggleProvider>
  );
}
